// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"143":"app","736":"vendor"}[chunkId] || chunkId) + "." + {"131":"1d43e574","143":"287bc0a4","226":"5c3a2977","532":"9054dad0","557":"3a65cbf5","736":"b41bd9a9","914":"963cfc3c"}[chunkId] + ".css";
};